import React, { Component } from 'react';
import LoadMask from 'Utils/LoadMask/LoadMask';
import Form from './EntityForm';

export default class EntityCreate extends Component {

    state = {
        editar: false,
        mensaje: 'Agregar Contribuyente',
        password: false,
    }

    componentWillMount(){
        if(this.props.match.params.id){
            this.props.detail(this.props.match.params.id);
            this.setState({
                editar: true,
                mensaje: 'Editar Contribuyente'
            });
        }
    }

    render() {
        const {
            create,
            update,
        } = this.props;

        const {
            updateData,
            cargando,
        } = this.props;

        return (
            <div className="content">
                <div className="m-auto row-fluid card-form">
                    <div className="table-decoration">
                        <LoadMask loading={cargando} blur_1>
                            {
                                this.state.editar ?
                                    <div>
                                        <div className="top-title">
                                            ENTES FINANCIEROS
                                        </div>
                                        <Form
                                        onSubmit={update}
                                        updateData={updateData}
                                        editando={true} />
                                    </div>
                            :
                                <div>
                                    <div className="top-title">
                                        CREAR ENTIDAD FINANCIERA
                                    </div>
                                    <Form onSubmit={create}/>
                                </div>
                            }
                        </LoadMask>
                    </div>
                </div>
            </div>
        )
    }
}
